import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer style={{
      backgroundColor: '#0a0b0d',
      borderTop: '1px solid #1c1f26',
      color: '#9ca3af',
      padding: '56px 20px 40px 20px',
      fontFamily: "'Largetransfer', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      fontSize: '13px'
    }}>
      <div style={{ maxWidth: '1120px', margin: '0 auto' }}>
        
        {/* Main Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '36px',
          marginBottom: '48px'
        }}>
          
          {/* Col 1: Brand & Overview */}
          <div style={{ maxWidth: '240px' }}>
            <Link to="/" style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              color: '#ffffff',
              fontWeight: '700',
              fontSize: '16px',
              textDecoration: 'none',
              marginBottom: '12px'
            }}>
              Largetransfer
            </Link>
            <p style={{ color: '#71717a', lineHeight: '1.6', fontSize: '12px', margin: '0 0 16px 0' }}>
              High-speed, encrypted large file delivery platform. Send up to 10GB free with zero download bandwidth egress fees.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '12px' }}>
              <span style={{ color: '#10b981', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#10b981' }}></span>
                All Systems Operational
              </span>
              <Link to="/status" style={{ color: '#9ca3af', textDecoration: 'none', fontSize: '11px', transition: 'color 0.15s' }}>
                View Live Uptime & Status
              </Link>
            </div>
          </div>

          {/* Col 2: Send Large Files */}
          <div>
            <div style={{ color: '#ffffff', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '14px' }}>
              Send Files
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
              <Link to="/send-large-files" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send Large Files Online</Link>
              <Link to="/send-10gb-file" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send 10GB File Free</Link>
              <Link to="/send-files-up-to-25gb" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send Files Up to 25GB</Link>
              <Link to="/send-50gb-file" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send Heavy 50GB Files</Link>
              <Link to="/send-large-video" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send Large Video Files</Link>
              <Link to="/send-video-without-compression" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Lossless Video Transfer</Link>
              <Link to="/share-large-folder" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Share Large Folders</Link>
              <Link to="/send-photos-to-someone" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send Photos Online</Link>
              <Link to="/share-raw-photos" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Share RAW Photos</Link>
              <Link to="/share-zip-files" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Share ZIP Archives</Link>
              <Link to="/send-design-files" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send Design Files</Link>
              <Link to="/send-large-files-to-client" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Client Deliverables</Link>
              <Link to="/upload-file-from-command-line" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Command Line (CLI)</Link>
            </div>
          </div>

          {/* Col 3: Alternatives */}
          <div>
            <div style={{ color: '#ffffff', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '14px' }}>
              Alternatives
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
              <Link to="/wetransfer-alternative" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>WeTransfer Alternative</Link>
              <Link to="/free-wetransfer-alternative" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Free WeTransfer (10GB)</Link>
              <Link to="/dropbox-alternative-send-files" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Dropbox Alternative</Link>
              <Link to="/google-drive-alternative-file-sharing" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Google Drive Alternative</Link>
              <Link to="/mega-alternative" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>MEGA Alternative</Link>
              <Link to="/pixeldrain-alternative" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Pixeldrain Alternative</Link>
              <Link to="/gofile-alternative" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Gofile Alternative</Link>
              <Link to="/mediafire-alternative" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>MediaFire Alternative</Link>
              <Link to="/smash-alternative" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Smash Alternative</Link>
              <Link to="/streamable-alternatives" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Streamable Alternative</Link>
              <Link to="/send-anywhere-alternative" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send Anywhere Alternative</Link>
              <Link to="/catbox-alternatives" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Catbox Alternative</Link>
              <Link to="/filetransfer-io-alternatives" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>FileTransfer.io Alternative</Link>
            </div>
          </div>

          {/* Col 4: Features & Performance */}
          <div>
            <div style={{ color: '#ffffff', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '14px' }}>
              Features
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
              <Link to="/anonymous-file-sharing" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Anonymous File Sharing</Link>
              <Link to="/share-files-securely" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Secure Encrypted Transfers</Link>
              <Link to="/temporary-file-sharing" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Auto-Expiring Links</Link>
              <Link to="/file-sharing-no-registration" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>No Registration Needed</Link>
              <Link to="/share-files-without-account" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Share Without Account</Link>
              <Link to="/transfer-files-without-email" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>No Email Required</Link>
              <Link to="/fast-file-sharing" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Gigabit Fast Sharing</Link>
              <Link to="/send-files-without-compression" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Zero Compression Lossless</Link>
              <Link to="/speedtest" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Edge Network Speed Test</Link>
              <Link to="/pricing" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Pricing Plans ($5/mo)</Link>
            </div>
          </div>

          {/* Col 5: Guides & Fixes */}
          <div>
            <div style={{ color: '#ffffff', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '14px' }}>
              Guides & Tutorials
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
              <Link to="/blog/how-to-send-large-video-files-online" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send Video Files Online</Link>
              <Link to="/blog/how-to-send-a-10gb-file-for-free" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send 10GB File Free</Link>
              <Link to="/blog/how-to-send-a-20gb-video-online" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send 20GB Video Online</Link>
              <Link to="/blog/how-to-send-a-50gb-file-online" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Send 50GB Heavy Files</Link>
              <Link to="/blog/how-to-share-premiere-pro-projects" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Premiere Pro Projects</Link>
              <Link to="/blog/how-to-share-blender-projects" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Blender 3D Projects</Link>
              <Link to="/blog/how-to-share-unreal-engine-game-builds" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Unreal Engine Game Builds</Link>
              <Link to="/file-too-large-to-email" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>File Too Large to Email</Link>
              <Link to="/mega-download-limit" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>MEGA Download Limit Fix</Link>
              <Link to="/is-pixeldrain-safe" style={{ color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}>Is Pixeldrain Safe?</Link>
              <Link to="/blog" style={{ color: '#ffffff', fontWeight: '600', textDecoration: 'none', transition: 'color 0.15s' }}>All Guides & Tutorials →</Link>
            </div>
          </div>

        </div>

        <nav
          aria-label="Popular site links"
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '10px',
            marginBottom: '28px',
            fontSize: '12px'
          }}
        >
          <Link to="/send-10gb-files" style={{ color: '#9ca3af', textDecoration: 'none' }}>Send 10GB Files</Link>
          <span style={{ color: '#4b5563' }} aria-hidden="true">|</span>
          <Link to="/wetransfer-alternative" style={{ color: '#9ca3af', textDecoration: 'none' }}>WeTransfer Alternative</Link>
          <span style={{ color: '#4b5563' }} aria-hidden="true">|</span>
          <Link to="/email-attachment-too-large" style={{ color: '#9ca3af', textDecoration: 'none' }}>Email Attachment Fix</Link>
          <span style={{ color: '#4b5563' }} aria-hidden="true">|</span>
          <Link to="/blog" style={{ color: '#9ca3af', textDecoration: 'none' }}>Blog</Link>
        </nav>

        {/* Sub-Footer */}
        <div style={{
          borderTop: '1px solid #1c1f26',
          paddingTop: '24px',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '16px',
          fontSize: '12px',
          color: '#71717a'
        }}>
          <div>
            © {new Date().getFullYear()} Largetransfer. Built with zero download egress architecture.
          </div>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <Link to="/blog" style={{ color: '#71717a', textDecoration: 'none' }}>Guides</Link>
            <Link to="/privacy-policy" style={{ color: '#71717a', textDecoration: 'none' }}>Privacy Policy</Link>
            <Link to="/terms-of-service" style={{ color: '#71717a', textDecoration: 'none' }}>Terms of Service</Link>
            <Link to="/dmca-policy" style={{ color: '#71717a', textDecoration: 'none' }}>DMCA Policy</Link>
            <Link to="/contact" style={{ color: '#71717a', textDecoration: 'none' }}>Contact</Link>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
